import script from "./UserInitiatives.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInitiatives.vue?vue&type=script&setup=true&lang=js"

import "./UserInitiatives.vue?vue&type=style&index=0&id=46d84924&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d84924"]])

export default __exports__